import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';
import { Styles } from 'react-jss';

const useSurveyStyles = createSurveyStyles(
  (theme: SurveyThemeType): Styles => ({
    surveyTitle: {
      color: theme?.titleColor || '#00bf6f',
      lineHeight: 1.25,
      paddingBottom: 24,
      ...theme?.surveyTitle,
      // reset font weight changed by the theme above
      '& strong': {
        fontWeight: 'bold !important',
      },
    },
  })
);

export default useSurveyStyles;
